export type TNativeMediaStreamAudioDestinationNode = MediaStreamAudioDestinationNode;
